import React, { useRef, useState } from 'react'
import { connect } from 'react-redux';
import { updateAlert, updateModelInputTypes, updateModelResultTypes } from '../../../redux/actions';
import { createChunks } from '../../../../../utils/fileFunctions';
import axios from 'axios';
import {
  // Pagination,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  DialogTitle,
  FormControl,
  Button,
  Select,
  InputLabel,
  MenuItem
} from "@mui/material";
import UserSelect from '../../../components/SelectField/UserSelect';

function AddModel({ open, setOpen, fullScreen, user, role, modelInputTypes, modelResultTypes, handleModelInputTypes, handleModelResultTypes, handleAlert }) {

  const [name, setName] = useState("");
  const [version, setVersion] = useState("");
  const [details, setDetails] = useState("");
  const [dataDescription, setDataDescription] = useState("");
  const [users, setUsers] = useState([user]);
  const [modelInputType, setModelInputType] = useState(1);
  const [modelResultType, setModelResultType] = useState(1);
  const [modelFile, setModelFile] = useState(null);

  const fileInputRef = useRef(null);

  const handleFileInputChange = (e) => {
    setModelFile(e.target.files[0]);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    if (!users.find(u => u.id === user.id) && role !== "Admin") {
      handleAlert("error", "Must include yourself as model owner!", 3000);
      return
    }
    if (!name || !version || !details || !dataDescription) {
      handleAlert("error", "Please finish all required parts!");
      return
    }

    const uids = users.map(user => user.id);

    if (modelFile) {
      const chunkSize = 5 * 1024 * 1024
      let mid = -1
      try {
        const chunks = createChunks(modelFile, chunkSize);
        for (let i = 0; i < chunks.length; i++) {
          const formData = new FormData();
          formData.append("files", chunks[i]);
          formData.append("uids", uids);
          formData.append("mid", mid);
          formData.append("index", i);
          formData.append("total", chunks.length);
          formData.append("name", name);
          formData.append("version", version);
          formData.append("details", details);
          formData.append("dataDescription", dataDescription);
          formData.append("modelInputType", modelInputType);
          formData.append("modelResultType", modelResultType);

          const result = await axios({
            method: "post",
            url: "/api/m2d/models/createModel",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          if (result.data.modelId) {
            mid = parseInt(result.data.modelId);
          }
        }

        setOpen(false);
        handleAlert("success", "Successfully submitted!");

      } catch (err) {
        setOpen(false);
        handleAlert("error", err.message, 3500);
      }
    } else {
      // upload without model file
      try {
        await axios({
          method: "post",
          url: "/api/m2d/models/createModelCard",
          data: {
            uids,
            name,
            version,
            details,
            dataDescription,
            modelInputType,
            modelResultType,
          }
        })
        setOpen(false);
        handleAlert("success", "Successfully submitted!")
      } catch (err) {
        setOpen(false);
        handleAlert("error", err.message, 3500);
        console.error(err);
      }
    }
  };

  // const handleModelUpload = () => {
  //   fileInputRef.current.click();
  // };

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Upload a new model
        </DialogTitle>
        <DialogContent>
          <div className="proj-add-info">
            Your model will be available once we approve.
          </div>

          <UserSelect setUsers={setUsers} users={users} sx={{ marginTop: '10px', marginBottom: '10px' }} />

          <FormControl
            fullWidth
            sx={{
              marginTop: "15px"
            }}
          >
            <InputLabel id="select-input-type" required>Input type</InputLabel>
            <Select
              labelId="select-input-type"
              value={modelInputType}
              label="Input type"
              onChange={(e) => setModelInputType(e.target.value)}
            >
              {modelInputTypes?.map((it) => {
                return <MenuItem key={it.id} value={it.id}>{it.type}</MenuItem>
              })}
            </Select>
          </FormControl>

          <FormControl
            fullWidth
            sx={{
              marginTop: "15px"
            }}
          >
            <InputLabel id="select-result-type" required>Result type</InputLabel>
            <Select
              labelId="select-result-type"
              value={modelResultType}
              label="Result type"
              onChange={(e) => setModelResultType(e.target.value)}
            >
              {modelResultTypes?.map((rt) => {
                return <MenuItem key={rt.id} value={rt.id}>{rt.type}</MenuItem>
              })}
            </Select>
          </FormControl>

          <TextField
            required
            label="Name"
            fullWidth
            margin="normal"
            onInput={(e) => setName(e.target.value)}
          />

          <TextField
            required
            label="Version"
            fullWidth
            margin="normal"
            onInput={(e) => setVersion(e.target.value)}
          />

          <TextField
            required
            label="Details"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            onInput={(e) => setDetails(e.target.value)}
          />

          <TextField
            required
            label="Data Description"
            fullWidth
            margin="normal"
            multiline
            minRows={3}
            maxRows={5}
            onInput={(e) => setDataDescription(e.target.value)}
          />

          <input
            type="file"
            hidden
            ref={fileInputRef}
            onChange={handleFileInputChange}
            accept=".zip, .rar"
          />
          <div className="model-file-upload">
            Please compress your model card (MUST BE IN MARKDOWN FORMAT),
            model, the script to run your model and your sample input file
            to a single .zip or .rar file and send it to hulabapps@emory.edu.
            Please note your email or username.
          </div>

          {/* <Button variant="contained" fullWidth onClick={handleModelUpload}>
              Upload model
            </Button>

            {modelFile ? (
              <div className="model-file-list">
                Choosen file: {modelFile.name}
              </div>
            ) : null} */}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Discard
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    role: state.m2d.role,
    modelInputTypes: state.m2d.modelInputTypes,
    modelResultTypes: state.m2d.modelResultTypes,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
    handleModelInputTypes(modelInputTypes) {
      updateModelInputTypes(modelInputTypes)(dispatch)
    },

    handleModelResultTypes(modelResultTypes) {
      updateModelResultTypes(modelResultTypes)(dispatch)
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddModel);